import { eachMinuteOfInterval, set, startOfDay, format } from 'date-fns';
import { WlcmOption } from '@wlcm/angular/core';

export const generateTimeOptions = (startHour: number, endHour: number, minutesStep: number = 30): WlcmOption[] => {
  const today: Date = new Date();

  const start: Date = set(startOfDay(today), { hours: startHour, minutes: 0 });

  const end: Date = set(startOfDay(today), { hours: endHour, minutes: 0 });

  const timePoints: Date[] = eachMinuteOfInterval({ start, end }, { step: minutesStep });

  return timePoints.map((time) => new WlcmOption(format(time, 'H:mm'), format(time, 'h:mmaaa')));
};

export function parseTimePoint(time: string): { hours: number; minutes: number } {
  const [hours, minutes] = time.split(':');

  return { hours: parseInt(hours), minutes: parseInt(minutes) };
}
